import React, { useEffect, useState } from "react";
import { ChildContainer, Container } from "../../components/Container/Containers";
import IMAGES from "../../assets/images/images";
import { Tabs } from "../../components/tabs/Tabs";
import MyIncidentViewer from "./myIncidents/list/myIncidentViewer.container";
import CloseTicketViewer from "./myServiceRequest/list/myserviceRequestViewer.container";
import styles from "./incidentManagement.module.css";
import AddTicket from "./myIncidents/add/addTicket.container";
import AddServiceRequest from "./myServiceRequest/add/addServiceRequest.container";
import {connect} from "react-redux";
import { setIncidentActiveTab} from "../../redux/actions/incidentManagement/incidentTab.action";
import { ADD_TICKET_ACTION, MY_INCIDENT_TABS, subTabs } from "../../utils/constants/incidentConstants";
import SectionGuard from "../../hoc/guards/SectionGuard";
import CAN from "../../casl/can";
import { Action, Resource } from "../../casl/constants";
import { USER_TYPE } from "../../utils/constants/userConstants";
import { NotificationOptions } from "../../redux/actions/notification/getEventNotificationList.action";
import { getModuleNotification } from "../../redux/actions/notification/getModuleNotification.action";
import { Banner } from "../../components/banner/Banners";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

const IncidentBanner =({myRights})=>{
  const isCustomer = myRights?.userType === USER_TYPE.CUSTOMER;

  return(
    <Banner
      image={IMAGES.vfbanner}
      text={isCustomer ? "My Tickets" : "Tickets"}
    >
      <SectionGuard canAccess={CAN(Action.CREATE,Resource.INCIDENTS) || CAN(Action.CREATE,Resource.SERVICE_REQUESTS)}>
        <div className={styles.description}>Raise an incident for issues needing resolution, or a service request for more service information.</div>
        <div className={styles.buttonContainer}>
          <div className={styles.buttondiv}>
            <SectionGuard canAccess={CAN(Action.CREATE,Resource.INCIDENTS)}>
            <AddTicket actionType={ADD_TICKET_ACTION.NEW_INCIDENT}/>
            </SectionGuard>
          </div>
          <div className={styles.buttondiv}>
            <SectionGuard canAccess={CAN(Action.CREATE,Resource.SERVICE_REQUESTS)}>
            <AddServiceRequest/>
            </SectionGuard>
          </div>
        </div>
      </SectionGuard>
    </Banner>
  )
}
const IncidentManagement = (props) => {
  const [activeTab, setActiveTab] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const subRoute = pathParts[2];
  // console.log("subRoute",subRoute)
  // const [tabOptions, setTabOptions] = useState([]);
  
   
   // if(CAN(Action.LIST, Resource.DEMANDS) && CAN(Action.LIST, Resource.LIVE_SERVICES)){
   //   setTabOptions([MY_INCIDENT_TABS.MY_INCIDENTS, MY_INCIDENT_TABS.MY_SERVICE_REQUEST]);
   // }else if(CAN(Action.LIST, Resource.LIVE_SERVICES)){
   //props.setIncidentActiveTab(MY_INCIDENT_TABS.MY_INCIDENTS);
   // }else if(CAN(Action.LIST, Resource.DEMANDS)){
    //props.setIncidentActiveTab(MY_INCIDENT_TABS.MY_SERVICE_REQUEST);
   // }

  //  const params= useParams();
  //  let ticketsParamData = null;
  //  useEffect(()=>{
  //   if(params.hasOwnProperty('data')){
  //     ticketsParamData = JSON.parse(params.data);
  //     if(ticketsParamData?.tab===MY_INCIDENT_TABS.MY_SERVICE_REQUEST){
  //       props?.setIncidentActiveTab(MY_INCIDENT_TABS.MY_SERVICE_REQUEST)
  //     }
  //   }
  //  },[])
   
   const tabOptions = [
       {
         key: MY_INCIDENT_TABS.MY_INCIDENTS,
         label: "Incidents",
         canAccess: CAN(Action.LIST,Resource.INCIDENTS),
         count:props?.notifications?.data?.INCIDENT?.length,
         routeUrl:'/incident-management/incidents'
       },
       {
         key: MY_INCIDENT_TABS.MY_SERVICE_REQUEST,
         label:"Service Requests",
         canAccess: CAN(Action.LIST,Resource.SERVICE_REQUESTS),
         count:props?.notifications?.data?.SERVICE_REQUEST?.length,
         routeUrl:'/incident-management/serviceRequests'
       }
     ];
     
  const getActiveTab = (tab) => {
    props.setIncidentActiveTab(tab);
    props.NotificationOptions();
    props.getModuleNotification();
  }

  const getIMAccess = (subRoute) => {
    const canAccessIncidentList = CAN(Action.LIST, Resource.INCIDENTS);
    const canAccessSRList = CAN(Action.LIST, Resource.SERVICE_REQUESTS);
    if(subRoute === "incidents"){
      return canAccessIncidentList;
    }else if(subRoute === "serviceRequests"){
      return canAccessSRList;
    }
  };

  return (
    <Container>
      {getIMAccess(subRoute)&&<>
      <IncidentBanner  myRights={props.myRights}/>
      <Tabs option={tabOptions} defaultActiveTab={subTabs[subRoute]} getActiveTab={getActiveTab} />
      </>}
      <ChildContainer>
        {/* {
          props.incidentActiveTab === MY_INCIDENT_TABS.MY_INCIDENTS?
           <MyIncidentViewer/>:
          props.incidentActiveTab === MY_INCIDENT_TABS.MY_SERVICE_REQUEST?
         <CloseTicketViewer/>:<></>
        } */}
        <Outlet/>
      </ChildContainer>
    </Container>
  )
};

// export default IncidentManagement;

const mapStateToProps = (state) => { 
  return {
    notifications: state.notifications.moduleNotification.data,
    incidentActiveTab:state.incidentTab.incidentActiveTab,
    myRights : state.myRights.myRights
  }
}

const mapDispatchToProps = (dispatch)=>{
  return {
    setIncidentActiveTab: (tab) => {
        return dispatch(setIncidentActiveTab(tab))
      },
    NotificationOptions: () => {
      return dispatch(NotificationOptions())
    },
    getModuleNotification: () => {
      return dispatch(getModuleNotification())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IncidentManagement);